module.exports = __webpack_public_path__ + "img/empty_2.2ebe4104.png";